import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  base_url, Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
//Material UI Imports
import {

  MenuItem,

} from '@mui/material';
import PropTypes from 'prop-types';
import $ from "jquery";

const ChequeFollowUp = () => {
  const [menu, setMenu] = useState(false);
  // const [data, setData] = useState([]);
  // const [dataa, setDataa] = useState([]);
  const [dataaa, setDataaa] = useState([]);
  const [dataoverview, setDataoverview] = useState({});
  const [permission, setPermission] = useState({});


  useEffect(() => {
        setPermission(FindModuleById(371)); 
console.log(permission);

    axios.post("/cheque-followup/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        if (response.data.code === 200) {
         // setData(response.data.data.cheques);
          //setDataa(response.data.data.cheques2);
          setDataaa(response.data.data.cheques3);
          setDataoverview(response.data.data.overview);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      }).catch((error) => {
        console.log(error);
      });
  }, []);


  const editItem = (item)=>{
    window.location.href = "/cheque-follow-ups-edit/"+item;
  }
 
  const statusOptions = ([
 
    { id: 1, title: "Collected", bg_color:"green", color:'white' },
    { id: 0, title: "Not Collected", bg_color:"red", color:'white' },
  ]);


 
    
  const changeOrderStatus = (user_id, status,type) =>{
    console.log(type);
    Swal.fire({
      title: 'Do you want change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/cheque-follow-ups/change-status/${user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                // $("#status-"+type+"-"+user_id).text(response.data.data.order_status.title);
                // $("#status-"+type+"-"+user_id).css('background-color',response.data.data.order_status.bg_color);
                // $("#status-"+type+"-"+user_id).css('color',response.data.data.order_status.color);
                Swal.fire(
                  'Changed!',
                  'Cheque Status has been changed Successfully.',
                  'success'
                );
                // setTimeout(() => {
                //  window.location.href = "/cheque-follow-ups";
                // }, 500);
                axios.post("/cheque-followup/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
                  .then((response) => {
                    if (response.data.code === 200) {
                      //setData(response.data.data.cheques);
                     // setDataa(response.data.data.cheques2);
                      setDataaa(response.data.data.cheques3);
                      setDataoverview(response.data.data.overview);
                    }
                    else  if (response.data.code === 401) {
                      window.location.href = "/login";
                    }else{
                      window.location.href = "/login"; 
                    }
                  }).catch((error) => {
                    console.log(error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/cheque-followup/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/cheque-follow-ups";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const CustomCell = ({ row }) => {
    return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-block dropdown-toggle me-1"
          style={{
            color: 'white',
            backgroundColor: row.original.cheque_status === 1 ? 'green' : 'red',
          }}
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {row.original.cheque_status === 1 ? 'Collected' : 'Not Collected'}
        </button>
        <div className="dropdown-menu">
          {statusOptions &&
            statusOptions.map((shipp) => (
              <button
                key={shipp.id} // ✅ Fixed missing key issue
                className="dropdown-item btn btn-block"
                style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
              >
                {shipp.title}
              </button>
            ))}
        </div>
      </div>
    );
  };
  
  // ✅ Define PropTypes validation
  CustomCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        cheque_status: PropTypes.number.isRequired,
        id: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  };




  const updateDate = async (id,type) =>{
    const { value: date } = await  Swal.fire({
          title: 'Cheque Collection Date',
          html: '<input type="date" id="datePicker" class="swal2-input">',
          showCancelButton: true,
          confirmButtonText: 'Update',
          cancelButtonText: 'Cancel',
          customClass: "swal-orders",
          preConfirm: () => {
            return document.getElementById('datePicker').value;
          }
        });
       
        if (date) {
          // Do something with the selected date
          console.log('Selected date:', date);
              axios.get(`/cheque-follow-ups/update-cheque-collection-date/${id}/${date}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
              .then((response) => {
                console.log(response);
                
                if (response.data.code === 200) {
                  $("#button-"+type+"-"+id).text(response.data.data.date);
                  Swal.fire(
                    'Changed!',
                    'Date Updated Successfully.',
                    'success'
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              }); 
        }
  
  }
  
  const ProductionDateCell = ({ row, permission, updateDate }) => {
    const { original } = row;
  
    return (
      <div>
        {permission?.update === 1 ? (
          <button
            className="btn btn-primary btn-block"
            id={`button-all-${original.id}`}
            onClick={() => updateDate(original.id, 'all')}
          >
            {original.cheque_collection_date ?? 'Update Date'}
          </button>
        ) : (
          <span>{original.cheque_collection_date ?? 'N/A'}</span>
        )}
      </div>
    );
  };
  
  
  // ✅ Define PropTypes
  ProductionDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        cheque_collection_date: PropTypes.string,
      }).isRequired,
    }).isRequired,
    permission: PropTypes.shape({
      update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    updateDate: PropTypes.func.isRequired,
  };

  // const columns =
  // [
  //    {
  //       accessorFn: (row) => `${(row.bank)?row.bank.title:""} `,
 
  //      header: 'Bank Name',
  //    },
  //    {
  //     accessorKey: 'cheque_designation', //normal accessorKey
  //     header: 'Cheque Designation',
  //   }, 
  //    {
  //      header: 'Amount',
  //      accessorFn: (row) => row.amount,
  //    },
  //    {
  //      accessorKey: 'date', //normal accessorKey
  //      header: 'Date',
  //    }, 
  //    {
  //      accessorKey: 'cheque_number', //normal accessorKey
  //      header: 'Cheque Number',
  //    }, 
  
  //    {
  //     header: 'Expense Type',
  //     accessorFn: (row) => `${(row.expense_type_detail)?row.expense_type_detail.title:""} `,
  //   },
  //   {
  //     header: 'Cheque Status',
  //     Cell: CustomCell, 
  //   },
  //   {
  //     header: 'Cheque Collection Date',
  //     accessorFn: (row) => row.cheque_collection_date || '',
  //     Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
  //   },
  //    {
  //      header: 'Created By',
  //      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
  //    },
  //    {
  //      header: 'Updated By',
  //      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
  //    },
    
  //  ];


   const columnss =
   [
      {
        // accessorKey: 'bank_name', //normal accessorKey
        accessorFn: (row) => `${(row.bank)?row.bank.title:""} `,
  
        header: 'Bank Name',
      },
      {
        accessorKey: 'cheque_designation', //normal accessorKey
        header: 'Cheque Designation',
      }, 
      {
        header: 'Amount',
        accessorFn: (row) => row.amount,
      },
      {
        accessorKey: 'date', //normal accessorKey
        header: 'Date',
      }, 
      {
        accessorKey: 'cheque_number', //normal accessorKey
        header: 'Cheque Number',
      }, 
   
      {
        header: 'Expense Type',
        accessorFn: (row) => `${(row.expense_type_detail)?row.expense_type_detail.title:""} `,
      },
      {
        header: 'Cheque Status',
        Cell: CustomCell, // ✅ Used separate component with PropTypes validation
      },
      {
        header: 'Cheque Collection Date',
        accessorFn: (row) => row.cheque_collection_date || '',
        Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
      },
      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
      },
     
    ];
    const downloadExcel = () => {
         
          window.open(`${base_url}/cheque-followup/listing-excel`, "_blank");
        };
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Cheque FollowUp</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Cheque FollowUp</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission && permission.list === 1 && (
                <Link to="/cheque-follow-ups-add" className="btn btn-primary me-1">
                  <i className="fas fa-plus"></i>
                </Link>
              )}

                &nbsp;&nbsp;
              {permission && permission.list === 1 && (
                <button className="btn btn-primary" onClick={downloadExcel}>
                  <i className="fa fa-file-excel-o"></i> <i className="fa fa-download"></i>
                  
                </button>
              )}
              </div>
            </div>
          </div>
          <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total</div>
                          <div className="dash-counts">
                            <p>{dataoverview.total}MAD</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total collected</div>
                          <div className="dash-counts">
                            <p>{dataoverview.completed}MAD</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Not collected </div>
                          <div className="dash-counts">
                            <p>{dataoverview.not_completed}MAD</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                      
                </div>

          <div className="row">
           
  
            <div className="col-sm-12" >
            <div className="card inovices-card w-100">
            <div className="card-body">
                 <div className="table-responsive">
                                          <MaterialReactTable columns={columnss} data={dataaa} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            //renderColumnActionsMenuItems 
                                          
                                            renderRowActionMenuItems={({ row }) => [
                                              permission?.update === 1 && (
                                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                  Edit
                                                </MenuItem>
                                              ),
                                              permission?.delete === 1 && (
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ),
                                            ]}
                                          />
                                          
                                          </div>
            {/* {permission && permission.list === 1 && ( 
      
                    <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">
                            
                          <li className="nav-item">
                                <a className="nav-link active" href="#bank3" data-bs-toggle="tab"> BMCE FFI</a>                                   
                            </li>   
                            <li className="nav-item">
                                <a className="nav-link " href="#listing-groupby-supplier" data-bs-toggle="tab">BMCE EO</a>                                  
                            </li>
                            <li className="nav-item">
                                <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Credit Agricole EO</a>                                   
                            </li>    
                                            
                            </ul>
                            <div className="tab-content">
                          
                            <div className="tab-pane " id="listing-groupby-supplier">
                            <div className="row"   id="listing-followup">
                              <div className="col-sm-12">
                                <div className="card card-table">
                                  <div className="card-body">
                                      <div className="table-responsive">

                                      <MaterialReactTable columns={columns} data={data} 
                                        enableColumnOrdering
                                        enablePinning
                                        enableRowActions
                                        renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                    />
                                      </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                              
                              </div>                                
                              <div className="tab-pane  " id="listing-all">
                                <div className="row"   id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">
                                          <MaterialReactTable columns={columnss} data={dataa} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            //renderColumnActionsMenuItems 
                                          
                                            renderRowActionMenuItems={({ row }) => [
                                              permission?.update === 1 && (
                                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                  Edit
                                                </MenuItem>
                                              ),
                                              permission?.delete === 1 && (
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ),
                                            ]}
                                          />
                                          
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              
                              </div>      

                                                        
                              <div className="tab-pane show active " id="bank3">
                                <div className="row"   id="listing-followfdfup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">
                                          <MaterialReactTable columns={columnss} data={dataaa} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            //renderColumnActionsMenuItems 
                                          
                                            renderRowActionMenuItems={({ row }) => [
                                              permission?.update === 1 && (
                                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                  Edit
                                                </MenuItem>
                                              ),
                                              permission?.delete === 1 && (
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ),
                                            ]}
                                          />
                                          
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              
                              </div>                            
                            
                            </div>                             
                        </div>
              )} */}
            </div>
             </div>





           </div>


          </div>
        </div>
      </div>
    </div>
  );
};
export default ChequeFollowUp;
